const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class Refugees extends Event {
    constructor(){
        super(
            Age.Age2,
            EventNames.Refugees,
            "The strongest scores 3 culture and gains 1 population. The weakest civilization loses 3 culture and 1 population.",
            {}
        )
    }
}

module.exports = Refugees;